import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { DidYouForgetPageRoutingModule } from './did-you-forget-routing.module';

import { DidYouForgetPage } from './did-you-forget.page';
import { SharedModule } from '../shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { DYFResolverService } from './services/did-you-forget-resolver.service';
import { DidYouForgetTracingEffects } from './tracking/tracing/did-you-forget-tracing.effects';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    DidYouForgetPageRoutingModule,
    EffectsModule.forFeature([DidYouForgetTracingEffects]),
  ],
  declarations: [DidYouForgetPage],
  providers: [DYFResolverService],
})
export class DidYouForgetPageModule {}
